import {
  Droplets, Disc, Cpu, CircleDot, Wrench, Cog,
  Zap, Snowflake, Move, ClipboardCheck,
} from "lucide-react";

export const SERVICES = [
  {
    id: "oil-fluid",
    title: "Oil Changes & Fluid Services",
    icon: Droplets,
    description:
      "Keep your engine running smoothly with regular oil changes and fluid maintenance.",
    sub: [
      "Conventional & synthetic oil changes",
      "Oil filter replacement",
      "Fluid level checks & top-ups",
      "Multi-point inspection included",
      "Transmission fluid service",
      "Coolant flush & fill",
    ],
  },
  {
    id: "brakes",
    title: "Brake Service & Repair",
    icon: Disc,
    description:
      "Your safety is our priority. We provide comprehensive brake inspection and repair services.",
    sub: [
      "Brake pad & rotor replacement",
      "Brake fluid flush",
      "ABS system diagnostics",
      "Emergency brake repair",
      "Brake line inspection",
      "Performance brake upgrades",
    ],
  },
  {
    id: "diagnostics",
    title: "Engine Diagnostics",
    icon: Cpu,
    description:
      "Advanced computer diagnostics to identify and resolve engine issues quickly.",
    sub: [
      "Check engine light diagnosis",
      "OBD-II scanning",
      "Sensor testing & replacement",
      "Performance analysis",
      "Emission system diagnostics",
      "Detailed diagnostic reports",
    ],
  },
  {
    id: "tires-alignment",
    title: "Tire & Alignment Services",
    icon: CircleDot,
    description:
      "Complete tire care from installation to rotation, balancing, and precision alignment using our state-of-the-art alignment hoist.",
    sub: [
      "Tire installation & balancing",
      "Wheel alignment",
      "Tire rotation",
      "Flat tire repair",
      "TPMS service",
      "Seasonal tire changeover",
    ],
  },
  {
    id: "engine-repair",
    title: "Engine Repair & Maintenance",
    icon: Wrench,
    description:
      "Expert engine repair and preventive maintenance to extend your vehicle's life.",
    sub: [
      "Timing belt replacement",
      "Spark plug replacement",
      "Engine tune-ups",
      "Belt & hose replacement",
      "Cooling system service",
      "Air filter replacement",
    ],
  },
  {
    id: "transmission",
    title: "Transmission Service",
    icon: Cog,
    description:
      "Keep your transmission shifting smoothly with our expert service and repair.",
    sub: [
      "Transmission fluid service",
      "Transmission diagnostics",
      "Clutch repair & replacement",
      "Transmission rebuilds",
      "Differential service",
      "Transfer case service",
    ],
  },
  {
    id: "electrical",
    title: "Electrical System Service",
    icon: Zap,
    description:
      "Comprehensive electrical system diagnostics and repair for all vehicle makes.",
    sub: [
      "Battery testing & replacement",
      "Alternator repair",
      "Starter motor service",
      "Wiring diagnostics",
      "Lighting system repair",
      "Electrical troubleshooting",
    ],
  },
  {
    id: "hvac",
    title: "Heating & Air Conditioning",
    icon: Snowflake,
    description:
      "Stay comfortable year-round with our HVAC service and repair.",
    sub: [
      "A/C recharge & repair",
      "Heater core service",
      "Blower motor replacement",
      "Climate control diagnostics",
      "Refrigerant leak detection",
      "Cabin air filter replacement",
    ],
  },
  {
    id: "suspension",
    title: "Suspension & Steering",
    icon: Move,
    description:
      "Smooth handling and a comfortable ride with our suspension and steering services.",
    sub: [
      "Shock & strut replacement",
      "Power steering service",
      "Ball joint replacement",
      "Control arm repair",
      "Sway bar service",
      "Steering rack repair",
    ],
  },
  {
    id: "pre-purchase",
    title: "Pre-Purchase Inspections",
    icon: ClipboardCheck,
    description:
      "Buying a used car? Get peace of mind with our thorough pre-purchase inspection.",
    sub: [
      "Comprehensive 150-point inspection",
      "Detailed written report",
      "Test drive evaluation",
      "Undercarriage inspection",
      "Diagnostic scan",
      "Fair market value assessment",
    ],
  },
];

export const SYMPTOMS = [
  { label: "Squeaking Brakes", serviceId: "brakes" },
  { label: "AC Blowing Warm Air", serviceId: "hvac" },
  { label: "Steering Pulls Left", serviceId: "tires-alignment" },
  { label: "Check Engine Light On", serviceId: "diagnostics" },
  { label: "Battery Won't Hold Charge", serviceId: "electrical" },
  { label: "Transmission Slipping", serviceId: "transmission" },
  { label: "Engine Knocking", serviceId: "engine-repair" },
  { label: "Rough Idle", serviceId: "diagnostics" },
  { label: "Oil Change Due", serviceId: "oil-fluid" },
  { label: "Rough Ride / Bumpy", serviceId: "suspension" },
];

export const FAQS = [
  {
    q: "Does your service void my manufacturer warranty?",
    a: "No. Under the Magnuson-Moss Warranty Act and Canadian consumer law, manufacturers cannot void your warranty for using an independent shop. Our ASE & Red Seal certified technicians follow OEM service procedures and document everything to keep your factory warranty fully intact.",
  },
  {
    q: "Do you use OEM parts?",
    a: "Yes. We default to OEM (Original Equipment Manufacturer) parts on warranty-covered vehicles and on critical safety systems. For older vehicles we also offer premium aftermarket alternatives — but you always choose, and every part is backed by a manufacturer warranty.",
  },
  {
    q: "How long does most service take?",
    a: "Most repairs are completed the same day. Oil changes and quick services take 30–60 minutes, brake jobs typically 2–3 hours, and major repairs receive a detailed timeline up front so you're never left guessing.",
  },
  {
    q: "Do you offer a written estimate before any work begins?",
    a: "Always. We provide a transparent, itemized written estimate before lifting a single wrench. No surprise charges — if we discover something mid-repair, we stop, call, and get your approval first.",
  },
  {
    q: "What payment methods do you accept?",
    a: "Visa, Mastercard, American Express, Interac e-Transfer, debit, and cash. Financing options are available for repairs over $1,000 — ask our service advisor for details.",
  },
  {
    q: "Do you service all makes and models?",
    a: "Yes — domestic, European, and Asian vehicles. From daily drivers to performance and luxury marques, our shop is equipped with dealership-level diagnostic tools for virtually every make on the road.",
  },
];

export const TRUST_BADGES = [
  { label: "Red Seal Certified", icon: "shield" },
  { label: "100% Satisfaction Guarantee", icon: "check" },
  { label: "Dealership-Level Precision", icon: "target" },
  { label: "Ottawa's #1 Rated Shop", icon: "trophy" },
];
